<div class="wrapper wrapper-full-page">
  <div class="full-page login-page">
    <layout-background></layout-background>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-md-offset-4 col-sm-8 col-sm-offset-2 col-xs-8 col-xs-offset-2">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<layout-footer></layout-footer>
